import { render } from "./post-smtp-gmail-one-click-banner.vue?vue&type=template&id=3571051b&scoped=true"
import script from "./post-smtp-gmail-one-click-banner.vue?vue&type=script&lang=js"
export * from "./post-smtp-gmail-one-click-banner.vue?vue&type=script&lang=js"

import "./post-smtp-gmail-one-click-banner.vue?vue&type=style&index=0&id=3571051b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3571051b"]])

export default __exports__